import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tick",
  "use": "icon-tick-usage",
  "viewBox": "0 0 406.834 406.834",
  "content": "<symbol viewBox=\"0 0 406.834 406.834\" id=\"icon-tick\">\n    <path fill=\"currentColor\" d=\"M385.621 62.507L146.225 301.901 21.213 176.891 0 198.104l146.225 146.223L406.834 83.72z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/tick.svg
// module id = 250
// module chunks = 2